/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Button, Check, Times } from '@fff-web/fff-ui-shared';
import { SUBSCRIPTION_PRICE_INCREASES } from '@fff-web/fff-utilities';
import { fffLogo } from '../../../../assets';
import { PlanCode } from '../../types';
import * as styles from './UpdateMembership.module.scss';

interface UpdateMembershipProps {
  onPlanSubmit(plan: PlanCode, cta: string): void;
  onClose(): void;
}

export const PERKS = [
  'Prepay for 4 boxes and save $60',
  'Limited offer: Get a FREE $200 mystery bundle',
  'Try our membership at no risk. We will offer your money back if you are not satisfied.',
];

export const KEEP_ANNUAL_LABEL = 'KEEP ANNUAL MEMBERSHIP';
export const CONTINUE_WITH_SEASONAL_LABEL = `Continue with Seasonal Membership for $${SUBSCRIPTION_PRICE_INCREASES.seasonal}/quarterly`;

export const TITLE = 'Don’t miss out on our Annual Membership perks!';

const UpdateMembership = ({ onPlanSubmit, onClose }: UpdateMembershipProps) => (
  /* TODO: Please fix the a11y issues with this element and then remove the comments at the top of the file. */
  <div className={styles.updateMembership}>
    <div className={styles.close} onClick={onClose}>
      <Times />
    </div>
    <img src={fffLogo} alt="FabFitFun logo" />
    <h1>{TITLE}</h1>
    <ul>
      {PERKS.map((perk) => (
        <li key={perk}>
          <Check />
          <p>{perk}</p>
        </li>
      ))}
    </ul>
    <div className={styles.wrapperButtons}>
      <Button onClick={() => onPlanSubmit(PlanCode.ANNUAL, KEEP_ANNUAL_LABEL)}>
        {KEEP_ANNUAL_LABEL}
      </Button>
      <Button onClick={() => onPlanSubmit(PlanCode.SEASONAL, CONTINUE_WITH_SEASONAL_LABEL)}>
        {CONTINUE_WITH_SEASONAL_LABEL}
      </Button>
    </div>
  </div>
);

export default UpdateMembership;
